'use client';

import { useEffect, useState } from 'react';

export const HINT_GLOW_IDLE_MS = 15_000;
/** One flash of the bulb, and how many play in a row. The web (`animate-hint-glow`) and native both follow these. */
export const HINT_GLOW_FLASH_MS = 1_600;
export const HINT_GLOW_FLASHES = 2;
export const HINT_GLOW_MS = HINT_GLOW_FLASH_MS * HINT_GLOW_FLASHES;

/**
 * Flashes the hint button's bulb a few times when the player has gone a while without a move, so
 * they notice hints are there. Each move restarts the wait. `isHintAvailable` is asked only once the
 * wait is up, so the hint search runs once per idle spell rather than on every move; a board with
 * no hint to give doesn't flash at all.
 */
export function useHintGlow(moveHistory: readonly unknown[], enabled: boolean, isHintAvailable: () => boolean) {
  const [glow, setGlow] = useState(false);
  useEffect(() => {
    if (!enabled || moveHistory.length === 0) return;
    let timer = setTimeout(() => {
      if (!isHintAvailable()) return;
      setGlow(true);
      timer = setTimeout(() => setGlow(false), HINT_GLOW_MS);
    }, HINT_GLOW_IDLE_MS);
    return () => {
      clearTimeout(timer);
      setGlow(false);
    };
  }, [moveHistory, enabled, isHintAvailable]);
  return glow;
}
